import { Col, Row } from 'react-bootstrap'

interface Props {
  value?: {
    perc: string
    num: number
  }
}
export default function NumPercCell ({ value }: Props): JSX.Element {
  return (
    <Row>
      <Col>{value?.num}</Col>
      <Col>{value?.perc}</Col>
    </Row>
  )
}
